<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="spaceDialog" width="90%" style="overflow: hidden;"
    :show-close="false" @open="spaceDialogEvt" @close="spaceCloseDiaEvt">
    <div class="spaceDialog_box">
      <!-- 图片 -->
      <div class="spaceDialogImg">
        <img style="width:100%;height: 100%;object-fit: contain;" :src="currentImage.review " alt="" />
        <div class="arrow_box">
          <div class="left" @click="arrowLeftEvt"></div>
          <div class="right" @click="arrowRightEvt"></div>
        </div>
      </div>
      <div style="width: 420px;">
        <p style="font-size: 18px;">{{ munList.d_id }}</p>
        <div style="display: flex;">
          <span>{{ currentImage.name}}</span>
          <span style="margin-left: 50px;"></span>
        </div>
        <el-tabs v-model="activeName" type="card" class="tab_E">
          <el-tab-pane label="基本信息" name="1">
            <img v-for="(star, index) in 5" :key="index" :src="getStarImage(index + 1)"
              style="width: 20px; cursor: pointer;" alt="" />
            <div style="display: flex; margin-top: 10px;">
              <div>
                <span>状态：</span>
                <span> {{ currentImage.encrypt_state === 0 ? '未审核' : currentImage.encrypt_state === 1 ? '保密' : '公开'
                  }}</span>
              </div>
              <div style="margin-left: 50px;">
                <span>版本</span><span> {{ currentImage.model_info.SavedAsVersion }}</span>
              </div>
            </div>
            <div style="width: 100%; margin-top: 50px;" class="top_e">
              <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
                <div class="zujian">
                  <span style="width: 70px;">文件大小</span>
                  <span>{{ formatBytes(currentImage.model_info.ZipSize) }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">Max大小</span>
                  <span>{{ formatBytes(currentImage.model_info.MaxSize) }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">贴图数量</span>
                  <span>{{ currentImage.model_info.Maps }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">贴图大小</span>
                  <span>{{ formatBytes(currentImage.model_info.MapSize) }}</span>
                </div>

                <div class="zujian">
                  <span style="width: 70px;">物体数</span>
                  <span>{{ currentImage.model_info.Objects }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">面数</span>
                  <span>{{ currentImage.model_info.Faces }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">顶点数</span>
                  <span>{{ currentImage.model_info.Vertices }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">线条</span>
                  <span>{{ currentImage.model_info.Shapes }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">灯光</span>
                  <span>{{ currentImage.model_info.Lights }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">相机</span>
                  <span>{{ currentImage.model_info.Cameras }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">插件</span>
                  <span style=" white-space: nowrap;font-size: 11px;">{{ currentImage.plugin.join(' ') }}</span>
                </div>
                <div class="zujian">
                  <span style="width: 70px;">渲染器</span>
                  <span>{{ currentImage.model_info.RendererName }}</span>
                </div>
              </div>
            </div>
            <div style="width: 100%; margin-top: 60px;" class="top_e">
              <div style="display: flex;flex-direction: column;">
                <div class="zujian_e">
                  <span>上传时间 :</span>
                  <span style="margin-left: 5px;">{{ currentImage.create_time }}</span>
                </div>
                <div class="zujian_e">
                  <span>修改时间 :</span>
                  <span style="margin-left: 5px;">{{ currentImage.update_time }}</span>
                </div>
                <div class="zujian_e">
                  <span>查看时间 :</span>
                  <span style="margin-left: 5px;">{{ currentImage.review_time }}</span>
                </div>
                <div class="zujian_e">
                  <span>下载时间 :</span>
                  <span style="margin-left: 5px;">{{ currentImage.last_download }}</span>
                </div>
                <div class="zujian_e">
                  <span>查看数量 :</span>
                  <span style="margin-left: 5px;">{{currentImage.review_num }}</span>
                </div>
                <div class="zujian_e">
                  <span>下载数量 :</span>
                  <span style="margin-left: 5px;">{{currentImage.download_num }}</span>
                </div>
                <div class="zujian_e">
                  <span>收藏数量 :</span>
                  <span style="margin-left: 5px;">{{ currentImage.favorite }}</span>
                </div>
              </div>
            </div>
            <div style="width: 100%; text-align: center; margin-top: 5px;" class="top_ev">
              <button class="btn_e">{{ currentImage.price }}</button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="标签" name="2">
            <div style="display: flex; flex-wrap: wrap;">
              <el-tag v-for="(tag, index) in currentImage.tag" :key="index" closable
                style="margin-top: 10px; margin-right: 5px;">
                {{ tag }}
              </el-tag>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <span slot="footer" class="dialog-footer"></span>
  </el-dialog>
</template>

<script>
export default {
  name: "SpaceDialog_e",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: Number,
      default: 0, // 默认值为 0
    },

  },
  data() {
    return {
      dialogVisible: this.visible,
      activeName: "1",
      changingImg: false,
      currentIndex: this.activeIndex,
      spaceWidth: "auto",
      spaceHeight: "auto",
      frontSpaceWidth: "500px",
      frontSpaceHeight: "300px",
      selectedStars: 0, // 当前选中的星星数量
      filledStar: require('../img/星星.png'), // 已选中星星的图标
      emptyStar: require('../img/星星 (1).png'), // 未选中星星的图标
      dataObject:{},
      tags:[],
      dataTab: [
        { label: "文件大小",},
        { label: "Max大小",},
        { label: "贴图数量",},
        { label: "贴图大小",},
        { label: "物体数",},
        { label: "面数  ",},
        { label: "顶点数 ",},
        { label: "线条  ",  },
        { label: "灯光  ",},
        { label: "相机  ",},
        { label: "插件  ",},
        { label: "渲染器 ",},
      ],
      dataOne: [
        { label: "上传时间"},
        { label: "修改时间", },
        { label: "查看时间",},
        { label: "下载时间",},
        { label: "查看数量",},
        { label: "下载数量",},
        { label: "收藏数量",},
      ],
      munList:{},
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
    activeIndex(newVal) {
      this.currentIndex = newVal; // 监听 activeIndex 的变化并更新 currentIndex
    },
  },

  computed: {
    // 获取当前显示的图片对象
    currentImage() {
      console.log(this.data[this.currentIndex]);


      return this.data[this.currentIndex] || {};
    }
  },
  mounted() {
  },
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },


    spaceDialogEvt() {
      if (this.data.length > 0) {
        this.munList = this.data[this.currentIndex]; // 根据 currentIndex 更新 munList
      } else {
        console.warn("No images available in data");
      }
    },
    arrowLeftEvt() {
      this.changingImg = true;
      this.currentIndex = (this.currentIndex - 1 + this.data.length) % this.data.length;
      setTimeout(() => {
        this.changingImg = false;
        this.munList = this.data[this.currentIndex]; // 更新 munList
      }, 300);
    },
    arrowRightEvt() {
      this.changingImg = true;
      this.currentIndex = (this.currentIndex + 1) % this.data.length;
      setTimeout(() => {
        this.changingImg = false;
        this.munList = this.data[this.currentIndex]; // 更新 munList
      }, 300);
    },


    spaceCloseDiaEvt() {
      // 关闭对话框时触发的事件
      console.log("Dialog closed");
      this.selectedStars = 0
      this.dialogVisible = false
    },


    getStarImage(index) {
      // 根据 currentImage.score 或 selectedStars 来决定显示哪种星星
      if (this.selectedStars > 0) {
        // 如果用户点击了星星，则优先使用 selectedStars
        return index <= this.selectedStars ? this.emptyStar : this.filledStar;
      } else {
        // 否则根据 currentImage.score 显示星星
        return index <= this.currentImage.score ? this.emptyStar : this.filledStar;
      }
    },
    selectStar(starCount) {
      if (this.selectedStars === starCount) {
        // 如果当前选中的星星数量与点击的星星数量相同，则重置为 0
        this.selectedStars = 0
      } else {
        // 否则设置为点击的星星数量
        this.selectedStars = starCount
      }
      console.log(this.selectedStars, 1)
    },

  },
};
</script>

<style scoped>
.spaceDialog_box {
  display: flex;
  justify-content: space-between;
}

.spaceDialogImg {
  position: relative;
}

.changing_box {
  position: absolute;
  top: 10px;
  right: 10px;
}

.arrow_box {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
}


.tab_E {
  margin-top: 20px;
}

.btn_e {
  padding: 10px 20px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn_e:hover {
  background-color: #66b1ff;
}

.spaceDialogImg {
  flex: 1;
  height: 88vh;
  min-width: 550px;
  display: flex;
  min-height: 400px;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  border-right: 1px solid #eee;
  background-color: rgb(200, 200, 200, 0.2);
  position: relative;
  overflow: hidden;
}





/deep/.input_e .el-input__inner {
  height: 35px !important;
}

.tab_E {
  margin-top: 10px;
}

/deep/.tab_E>.el-tabs__header {
  border: none !important;
}

/deep/.tab_E .el-tabs__nav {
  border: 1px solid #E4E7ED;
  height: 35px !important;
}

/deep/.tab_E .el-tabs__item {
  line-height: 34px !important;
}

/deep/.tab_E .is-active {
  background-color: #e5e5e5;
  color: #000;
}

.btn_e {
  width: 300px;
  height: 40px;
  border-radius: 50px;
  background: #dd117a;
  color: #fff;
  font-size: 14px;
}



.arrow_box {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.arrow_box div {
  width: 10% ;
  height: 100% ;
}

.arrow_box .left:hover {
  cursor: url("../backHome/components/cur/left.png"), auto;
}

.arrow_box .right:hover {
  cursor: url("../backHome/components/cur/right.png"), auto;
}
.zujian{
  width:200px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    display: flex;
}
.zujian_e{
  width: 400px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    display: flex;
    font-size: 14px;
}

@media screen and (min-width:0px) and (max-width: 1920px) {
.zujian_e{
  height: 40px !important;
  line-height: 40px !important;
}
  .zujian{
    height: 40px !important;
  }
  .top_e{
    margin-top:10px !important;
  }
    .spaceDialogImg {
      flex: 1;
      height: 85vh !important;
      min-width: 550px;
      display: flex;
      min-height: 400px;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      border-right: 1px solid #eee;
      background-color: rgb(200, 200, 200, 0.2);
      position: relative;
      overflow: hidden;
    }
      /deep/.el-dialog__wrapper {
        display: flex ;
        align-items: baseline !important;
      }
}

/deep/.el-dialog__wrapper{
  display: flex;
    justify-items: center;
    align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/SpaceDialog_e.vue